import fjarrvarmeKalkylatorForetag from './modules/fjarrvarme-kalkylator-foretag';
import app                        from '../shared/shared';

app.registerModules([
  fjarrvarmeKalkylatorForetag
]);

